const domEvents: StandardObjectInterface = {
    templateInstantiated: 'template-instantiated'
};

export default domEvents;
